import { Redirect } from 'react-router-dom';
import { useBreakpoint } from 'app/spacing';
import { MobileFallback } from 'pages/Common/MobileFallback';
import { useBusinessAppPermissions } from 'pages/BusinessApps/permissions';
import { APPS_TAB_PATHS } from 'pages/Apps/constants';
import { PreviewEndedToasts } from './components/PreviewEndedToasts';
import { BusinessAppDetailsPage } from './subpages/Details';

export const BusinessAppsPage = () => <Redirect to={APPS_TAB_PATHS.develop} />;

export const BusinessAppDetailsRoute = () => {
  const isMobile = useBreakpoint();
  const { canViewBusinessApps } = useBusinessAppPermissions();

  if (!canViewBusinessApps) {
    return <Redirect to="/" />;
  }

  return (
    <MobileFallback isMobile={isMobile}>
      <PreviewEndedToasts />
      <BusinessAppDetailsPage />
    </MobileFallback>
  );
};
